import { batch, useSelector } from 'react-redux';
import { Tabs } from 'shared/components/Tabs';
import { useAppDispatch } from 'shared/hooks';
import { selectOffersCount, selectDealTypeFilter } from 'shared/selectors/offers';
import { setDealType, setRoomTypes } from 'shared/slices/offers';
import { EDealType } from 'shared/types/offers';
import { trackDealTypeFilterChange } from '../../tracking';
import { useAwaitingTracking, useGetOffersByDeviceType } from '../../hooks';
import { useCallback } from 'react';

const options = [
  { title: 'Купить', value: EDealType.Sale },
  { title: 'Снять надолго', value: EDealType.RentLongterm },
  { title: 'Снять посуточно', value: EDealType.RentDaily },
];

export const DealTypeFilterContainer = () => {
  const dispatch = useAppDispatch();
  const getOffers = useGetOffersByDeviceType();
  const dealTypeValue = useSelector(selectDealTypeFilter);
  const offersCount = useSelector(selectOffersCount);

  const memoizedTracking = useCallback(() => {
    trackDealTypeFilterChange({ dealType: dealTypeValue, count: offersCount });
  }, [dealTypeValue, offersCount]);

  const awaitTracking = useAwaitingTracking(memoizedTracking);

  const handleChange = async (value: EDealType) => {
    batch(() => {
      dispatch(setDealType(value));
      dispatch(setRoomTypes(null));
    });
    getOffers();
    awaitTracking();
  };

  return <Tabs items={options} activeValue={dealTypeValue} onClick={handleChange} />;
};
